<template>
  <div class="bubble-text-row"><slot/></div>
</template>
<script>
export default {
  name: 'BubbleTextRow'
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.bubble-text-row {
  font-size: 11px;
  color: $color_dark_text;
  word-break: break-word;
  white-space: pre-wrap;
  font-weight: 500;
}
</style>
